import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const guardrailCompliancePlugin = createPlugin({
  id: 'guardrail-compliance',
  routes: {
    root: rootRouteRef,
  },
});

export const GuardrailCompliancePage = guardrailCompliancePlugin.provide(
  createRoutableExtension({
    name: 'GuardrailCompliancePage',
    component: () =>
      import('./components/GuardrailCompliancePage').then(
        m => m.GuardrailCompliancePage,
      ),
    mountPoint: rootRouteRef,
  }),
);
